// FLAGS: personal-data
// Reads the signed-in user's saved profile language from the stored user, for the boot to hand to i18n as one of
// its language inputs. The stored user is written on login and on every profile fetch, so a same-tab reload has
// it before React mounts; a fresh tab does not, and the profile-language hook applies it once the profile arrives.
// Only the language code leaves this module — i18n never sees the user record.
import sessionStorageService from "@src/services/sessionStorage.service";

const getStoredProfileLanguage = (): string | undefined => {
  const code: unknown = sessionStorageService.getUser()?.languageCode;
  return typeof code === "string" && code !== "" ? code : undefined;
};

export default getStoredProfileLanguage;
